import { render, staticRenderFns } from "./GeneralPrompt.vue?vue&type=template&id=ed4f4a0e"
import script from "./GeneralPrompt.vue?vue&type=script&lang=js"
export * from "./GeneralPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports